import type { FormInstance } from 'antd'

export interface ThresholdConfig {
  enabled: boolean
  threshold?: number
}

export type ConfigType = 'auto_match_rules' | 'auto_approve_rules' | 'warning_rules'

export interface ConfigField {
  key: string
  name: string
  description?: string
  unit?: '%' | '$' | 'hrs'
  // Define which columns this field appears in
  columns: {
    match?: boolean | 'always' // 'always' means it's always enabled
    approve?: boolean
    warning?: boolean
  }
  isSection?: boolean
}

export interface UnifiedConfigTableProps {
  form: FormInstance
  onFormChange?: () => void
}

export interface ConfigSwitchProps {
  form: FormInstance
  configType: ConfigType
  field: ConfigField
  alwaysEnabled?: boolean
  onFormChange?: () => void
}

export const CONFIG_COLUMN_WIDTH = 140
